import React from 'react';
import { useTranslation } from "react-i18next";
import Menu from '../Menu';
import TaxFormForm from "./TaxFormForm";

const TaxForm = () => {
  const {t} = useTranslation();

  return (
      <>
        <Menu />
        <TaxFormForm />
      </>
  );
}

export default TaxForm;